import { FC, useState } from "react";
import {
  DialogContent,
  DialogActions,
  Typography,
  Button,
  FormLabel,
  Box,
  IconButton,
} from "@material-ui/core";
import api from "api";
import PdfIcon from "icon/pdfIcon.png";
import ClearIcon from "@material-ui/icons/Clear";
import { ellipsis } from "utils/formats";
import { closeModal } from "actions/modalActions";
import { useDispatch } from "react-redux";
import { useDialogStyles } from "../styles";
import { customToast } from "hooks/toast";
import { DialogButton } from "components/buttons/DialogButton";;

interface UploadWeeklyDnrFileDialogProps {}

export const UploadWeeklyDnrFileDialog: FC<UploadWeeklyDnrFileDialogProps> = () => {
  const classes = useDialogStyles();
  const [file, setFile] = useState<File | null>(null);
  const dispatch = useDispatch();

  const onClose = () => dispatch(closeModal());

  const handleClose = () => {
    setFile(null);
    onClose();
  };

  const handleSubmit = (file: File | null) => {
    if (file != null) {
      handleClose();
      const request: any = new FormData();
      request.append("csv_file", file);
      api.uploadDnr(request).then((res) => {
        if (res.data) {
          customToast("success", "CSV file was uploaded!");
        }
      });
    }
  };

  const onClear = () => {
    setFile(null);
  };

  return (
    <>
      <DialogContent
        data-testid="uploadFileDialog"
        className={classes.modelContentDefaults}
        style={{ justifyContent: "space-between" }}
      >
        <FormLabel htmlFor="btn-upload">
          <input
            id="btn-upload"
            name="btn-upload"
            style={{ display: "none" }}
            type="file"
            accept="application/csv"
            onChange={(e) => {
              if (e?.target?.files?.[0]) {
                setFile(e?.target?.files?.[0]);
              }
            }}
          />
          <Button
            fullWidth
            className="btn-choose"
            component="span"
            color="primary"
            variant="contained"
          >
            Choose File
          </Button>
        </FormLabel>
        {file ? <FileCard file={file} onClear={onClear} /> : null}
      </DialogContent>
      <DialogActions data-testid="uploadFileDialogActions" className={classes.dialogActions}>
        <DialogButton
          testId={"cancelUploadFileDialogeButton"}
          buttonText={"Cancel"}
          onClick={onClose}
          variant="contained"
          color="secondary"
        />
        <DialogButton
          testId={"uploadUploadFileDialogButton"}
          buttonText={"Upload"}
          onClick={() => handleSubmit(file)}
          variant="contained"
          color="primary"
          disabled={file === null}
        />
      </DialogActions>
    </>
  );
};

const FileCard = ({ file, onClear }: { file: File; onClear: () => void }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", my: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img src={PdfIcon} height="40" alt="logo" />
        <Box sx={{ mx: 2 }}>
          <Typography>
            {ellipsis(file.name)} ({Number(file.size / 1000000).toFixed(2)} MB)
          </Typography>
        </Box>
      </Box>
      <IconButton onClick={onClear}>
        <ClearIcon />
      </IconButton>
    </Box>
  );
};
